exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".emoji-picker-react img.emoji-img {\n    height: 25px;\n    width: 25px;\n    margin: 5px;\n}\n", ""]);
